<template lang="html">
  <modal :short="true" :closeFunction="closeModal">
    <template slot="modal-header">
      <div class="header-wrapper">
        <div class="preview-modal preview-modal__header">
          <close-button @closeModal="closeModal"></close-button>
        </div>
      </div>
    </template>
    <template slot="modal-body">
      <div class="d-flex flex-column preview-modal preview-modal__wrapper">
        <div
          class="d-flex justify-content-between align-items-center px-3 py-2 preview-modal__navbar"
        >
          <div class="d-flex">
            <h4 class="h5 mb-0 preview-modal__title">Creative Preview</h4>
          </div>
          <div class="preview-modal__button-wrapper">
            <button
              class="preview-modal__button preview-modal__button--left"
              @click="() => this.contentIndex--"
              :disabled="this.contentIndex === 0"
            >
              <Icon
                icon="bx:bxs-left-arrow"
                class="bx bxs-left-arrow px-1 font-size-14"
              />
            </button>
            <button
              class="preview-modal__button preview-modal__button--right"
              @click="() => this.contentIndex++"
              :disabled="this.contentIndex + 1 === this.ads.length"
            >
              <Icon
                icon="bx:bxs-right-arrow"
                class="bx bxs-right-arrow px-1 font-size-14"
              />
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div></div>
          <div>
            <span class="page-counter"
              >{{ this.contentIndex + 1 }} of {{ this.ads.length }}
            </span>
          </div>
        </div>
        <div
          v-for="(ad, index) in ads"
          :key="ad.id"
          v-show="contentIndex == index"
          class="centered-content"
        >
          <h3 class="align_center">{{ ad.name }}</h3>
          <div :id="ad.id" class="d-flex justify-content-center"></div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../../helpers/Modal';
import PropertyService from '../../services/properties';
import AgencyServices from '../../services/agencies';
import URLHelpers from '../../helpers/URLHelpers';
import CloseButton from '../../helpers/CloseButton';
import {Icon} from '@iconify/vue2';

export default {
  components: {
    Modal,
    CloseButton,
    Icon,
  },
  props: {
    propertyId: String,
    agencyId: String,
    campaign: Object,
    extendCampaign: Object,
    closeModal: Function,
    logoUrl: String,
  },
  data() {
    return {
      ads: [
        {
          name: '160x600',
          id: 'creative_160_600',
        },
        {
          name: '300x600',
          id: 'creative_300_600',
        },
        {
          name: '300x250',
          id: 'creative_300_250',
        },
        {
          name: '970x250',
          id: 'creative_970_250',
        },
        {
          name: 'Meta Ad',
          id: 'creative_meta_ad',
        },
      ],
      contentIndex: 0,
    };
  },
  methods: {
    extractParams(url) {
      return {
        ca: URLHelpers.getParameterByName('ca', url) || null,
        cr: URLHelpers.getParameterByName('cr', url) || null,
      };
    },
    normalizeImageList(data) {
      if (!Array.isArray(data.ImageList)) {
        return [data.ImageList];
      }
      return data.ImageList;
    },
    appendLogo(data) {
      if (this.logoUrl) {
        data.BlobData = {};
        data.BlobData.Logo = this.logoUrl;
      }
      return data;
    },
    renderPreview(ca, cr, width, height, elementId, data) {
      // SetTimeout is needed to prevent loopa from failing in a certain combination of creatives
      setTimeout(() => {
        loopaPreviews.getPreview(
          ca,
          cr,
          'au',
          width,
          height,
          document.getElementById(elementId),
          data
        );
      }, 0);
    },
    populateSignifiPreview(clientIntegration, width, height, data, type) {
      const {ca, cr} = this.extractParams(
        clientIntegration[type + 'Creative' + width + height]
      );

      data.ImageList = this.normalizeImageList(data);
      data = this.appendLogo(data);

      const elementId = 'creative_' + width + '_' + height;
      if (ca && cr) {
        this.renderPreview(ca, cr, width, height, elementId, data);
      } else {
        //Remove ads without available properties
        this.ads = this.ads.filter(function(obj) {
          return obj.id !== elementId;
        });
      }

      if (this.ads.length == 0) {
        this.closeModal();
      }
    },
    populateMetaAdPreview(url, data) {
      const {ca, cr} = this.extractParams(url);

      data.ImageList = this.normalizeImageList(data);
      data = this.appendLogo(data);

      const elementId = 'creative_meta_ad';
      if (ca && cr) {
        this.renderPreview(ca, cr, 321, 524, elementId, data);
      } else {
        //Remove ads without available properties
        this.ads = this.ads.filter(function(obj) {
          return obj.id !== elementId;
        });
      }

      if (this.ads.length == 0) {
        this.closeModal();
      }
    },
  },
  computed: {},
  mounted() {
    if (this.agencyId) {
      AgencyServices.getSignifiProductData(this.agencyId, this.campaign).then(
        (data) => {
          this.populateSignifiPreview(
            data.clientIntegration,
            160,
            600,
            data.productData,
            this.campaign.type
          );
          this.populateSignifiPreview(
            data.clientIntegration,
            300,
            600,
            data.productData,
            this.campaign.type
          );
          this.populateSignifiPreview(
            data.clientIntegration,
            300,
            250,
            data.productData,
            this.campaign.type
          );
          this.populateSignifiPreview(
            data.clientIntegration,
            970,
            250,
            data.productData,
            this.campaign.type
          );
          this.populateMetaAdPreview(
            data.clientIntegration[`${this.campaign.type}MetaAdPreview`],
            data.productData
          );
        }
      );
    } else if (this.propertyId) {
      PropertyService.getSignifiProductData(this.propertyId, {
        ...this.extendCampaign,
        note: this.campaign.note,
      }).then((data) => {
        this.populateSignifiPreview(
          data.clientIntegration,
          160,
          600,
          data.productData,
          'property'
        );
        this.populateSignifiPreview(
          data.clientIntegration,
          300,
          600,
          data.productData,
          'property'
        );
        this.populateSignifiPreview(
          data.clientIntegration,
          300,
          250,
          data.productData,
          'property'
        );
        this.populateSignifiPreview(
          data.clientIntegration,
          970,
          250,
          data.productData,
          'property'
        );
        this.populateMetaAdPreview(
          data.clientIntegration['propertyMetaAdPreview'],
          data.productData
        );
      });
    }
  },
};
</script>
